import _ from 'lodash';
import releases from './releases.json';
import changelog from './appliance.json';

export default function generateApplianceReleases() {
  const releasesApplianceReleases = releases.slice(0).map(release => {
    const newRelease = _.merge({}, release);
    const releaseLog = changelog
      .filter(log => log.release === newRelease.id)
      .sort((a, b) => a.type.localeCompare(b.type)); // Sort by Type

    // Group by Type
    newRelease.changelog = groupBy(releaseLog, item => item.type);

    // Sort by module
    Object.keys(newRelease.changelog).forEach(key => {
      newRelease.changelog[key].sort((a, b) => a.module.localeCompare(b.module));
    });

    return newRelease;
  });

  return releasesApplianceReleases;
}

/** * HELPER FUNCTIONS ***/

function groupBy(array, f) {
  const groups = {};
  array.forEach(o => {
    let group = JSON.stringify(f(o));
    if (group) {
      group = group.replace(/\"([^(\")"]+)\":/g, '$1:');
    }

    groups[group] = groups[group] || [];
    groups[group].push(o);
  });

  return groups;
}



// WEBPACK FOOTER //
// ./src/pages/changelog/generate-releases.js